import { cn } from "../lib/utils.js";
import "react";
import { CaretDown } from "@phosphor-icons/react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/accordion.tsx
/** Form-style by default - multiple sections open concurrently. */
const Accordion = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx(AccordionPrimitive.Root, {
		"data-slot": "accordion",
		className: cn("tw:flex tw:flex-col tw:gap-2", className),
		...props
	});
};
const AccordionItem = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx(AccordionPrimitive.Item, {
		"data-slot": "accordion-item",
		className: cn("tw:rounded-xs tw:border tw:border-stroke tw:bg-white tw:py-4", "tw:has-[:focus-visible]:ring-2 tw:has-[:focus-visible]:ring-midnight/40 tw:has-[:focus-visible]:ring-inset tw:has-[:focus-visible]:ring-offset-0", className),
		...props
	});
};
const AccordionHeaderRow = ({ className, ...props }) => /* @__PURE__ */ jsx("div", {
	"data-slot": "accordion-header-row",
	className: cn("tw:flex tw:min-w-0 tw:items-center tw:pr-5", className),
	...props
});
const AccordionTrigger = ({ className, children, subtitle, ...props }) => {
	return /* @__PURE__ */ jsx(AccordionPrimitive.Header, {
		className: "tw:m-0 tw:flex tw:flex-1 tw:min-w-0 tw:items-center",
		children: /* @__PURE__ */ jsxs(AccordionPrimitive.Trigger, {
			"data-slot": "accordion-trigger",
			className: cn("tw:group tw:flex tw:flex-1 tw:min-w-0 tw:w-full tw:items-center tw:justify-between tw:gap-3 tw:py-0 tw:px-5 tw:text-left tw:text-base tw:font-semibold tw:text-[#333] tw:new:text-midnight tw:cursor-pointer tw:border-0 tw:bg-transparent tw:focus:outline-hidden tw:focus-visible:outline-hidden", className),
			...props,
			children: [/* @__PURE__ */ jsxs("span", {
				className: "tw:flex tw:flex-1 tw:min-w-0 tw:flex-col tw:gap-0.5",
				children: [/* @__PURE__ */ jsx("span", {
					className: "tw:block tw:min-w-0 tw:whitespace-normal tw:break-words",
					children
				}), subtitle && /* @__PURE__ */ jsx("span", {
					className: "tw:text-sm tw:font-normal tw:leading-snug tw:text-midnight/75 tw:whitespace-normal tw:break-words",
					children: subtitle
				})]
			}), /* @__PURE__ */ jsx(CaretDown, { className: cn("tw:size-4 tw:shrink-0 tw:transition-transform tw:duration-[280ms] tw:ease-[cubic-bezier(0.16,1,0.3,1)] tw:text-midnight/60", "tw:group-data-[state=open]:rotate-180 tw:group-data-[state=open]:text-midnight", "tw:group-hover:text-midnight") })]
		})
	});
};
const AccordionContent = ({ className, children, ...props }) => {
	return /* @__PURE__ */ jsx(AccordionPrimitive.Content, {
		"data-slot": "accordion-content",
		className: "tw:overflow-hidden tw:data-[state=closed]:animate-accordion-up tw:data-[state=open]:animate-accordion-down",
		...props,
		children: /* @__PURE__ */ jsx("div", {
			className: cn("tw:px-5 tw:pt-2 tw:[&>h1]:m-0 tw:[&>h2]:m-0 tw:[&>h3]:m-0 tw:[&>h4]:m-0 tw:[&>ol]:m-0 tw:[&>p]:m-0 tw:[&>ul]:m-0", className),
			children
		})
	});
};
//#endregion
export { Accordion, AccordionContent, AccordionHeaderRow, AccordionItem, AccordionTrigger };

//# sourceMappingURL=accordion.js.map